import api from '../services';
import { getLocalStorage, getUser } from '../utils/func';
import config from '../utils/config';
import { inAppPreferencesChanged } from '../inApp/signals';

let queueOwner, tail = Promise.resolve();
export const preferenceOwner = () => `${getUser()?.id || ''}:${getLocalStorage(config.token) || ''}`;
const sessionChanged = () => new Error('PUSH_SESSION_CHANGED');

function queue(owner) {
  if (owner !== preferenceOwner()) throw sessionChanged();
  if (queueOwner !== owner) { queueOwner = owner; tail = Promise.resolve(); }
  return tail;
}

// Keep writes ordered even after leaving settings. A late "on" must never
// overtake a newer "off", and queued work must never use another account's token.
export function saveNotificationPreference(group, key, value, owner) {
  const work = queue(owner).then(async () => {
    if (owner !== preferenceOwner()) throw sessionChanged();
    const result = await api.userPreferencesSave({ [group]: { [key]: value } });
    if (owner !== preferenceOwner()) throw sessionChanged();
    if (!result?.success) throw new Error('PREFERENCE_SAVE_FAILED');
    if (group === 'in_app' && result.preferences?.in_app) inAppPreferencesChanged(result.preferences.in_app);
    return result;
  });
  tail = work.catch(() => {});
  return work;
}

export async function readNotificationPreferences(options) {
  const owner = preferenceOwner();
  await queue(owner);
  if (owner !== preferenceOwner()) throw sessionChanged();
  const result = await api.userPreferences(undefined, options);
  if (owner !== preferenceOwner()) throw sessionChanged();
  return result;
}
